import {
  AIStatusBadge,
  IconMagicSolid,
  InfoBadge,
  InfoBadgeTypes,
  Space,
  SubText,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  GlobalSearchWorkflowContentStyled,
  GlobalSearchWorkflowIconStyled,
  GlobalSearchWorkflowListStyled,
  GlobalSearchWorkflowStyled,
  GlobalSearchWorkflowsHeadingStyled,
  GlobalSearchWorkflowTitleStyled,
} from './styles/GlobalSearchWorkflowsStyled'

interface IGlobalSearchWorkflowsProps {
  onStartGuidedIntake: () => void
}

export const GlobalSearchWorkflows = ({
  onStartGuidedIntake,
}: IGlobalSearchWorkflowsProps) => {
  const intl = useProcurifyIntl()

  return (
    <>
      <GlobalSearchWorkflowsHeadingStyled color='textSecondary'>
        {intl.formatMessage(messages.heading)}
      </GlobalSearchWorkflowsHeadingStyled>
      <GlobalSearchWorkflowListStyled
        aria-label={intl.formatMessage(messages.listAriaLabel)}
      >
        <li>
          <GlobalSearchWorkflowStyled
            type='button'
            data-analytics-id='global-command-start-guided-intake'
            onClick={onStartGuidedIntake}
          >
            <GlobalSearchWorkflowIconStyled aria-hidden='true'>
              <IconMagicSolid size={24} color='ai' />
            </GlobalSearchWorkflowIconStyled>
            <GlobalSearchWorkflowContentStyled>
              <Space size='xsmall' align='start'>
                <Space direction='horizontal' size='small' align='center'>
                  <GlobalSearchWorkflowTitleStyled inline>
                    {intl.formatMessage(messages.startGuidedIntakeTitle)}
                  </GlobalSearchWorkflowTitleStyled>
                  <AIStatusBadge
                    size='small'
                    text={intl.formatMessage(messages.aiBadge)}
                  />
                  <InfoBadge
                    type={InfoBadgeTypes.NEUTRAL}
                    size='small'
                    text={intl.formatMessage(messages.betaBadge)}
                  />
                </Space>
                <SubText color='textSecondary'>
                  {intl.formatMessage(messages.startGuidedIntakeDescription)}
                </SubText>
              </Space>
            </GlobalSearchWorkflowContentStyled>
          </GlobalSearchWorkflowStyled>
        </li>
      </GlobalSearchWorkflowListStyled>
    </>
  )
}
